<template>
  <div
    id="pie-chart"
    class="pie-chart"
  />
</template>

<script>
import debounce from 'lodash/debounce';
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme

export default {
  props: {
    totalstake: {
      type: Number,
    },
    totalnostake: {
      type: Number,
    }
  },
  data() {
    return {
      chart: null,
      dataIndex: -1
    };
  },
  computed: {
    showToolTip() {
      return this.$store.state.home.showToolTip
    }
  },
  watch: {
    // 用于移动端控制 tooltip 隐藏。
    showToolTip(v) {
      if (!v) {
        this.chart.dispatchAction({ type: 'downplay' })
        this.chart.dispatchAction({ type: 'hideTip' })
      } else {
        this.chart.dispatchAction({ type: 'highlight', dataIndex: this.dataIndex })
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart)
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeChart: debounce(() => {
      const chart = echarts.init(document.getElementById("pie-chart"));
      chart.resize();
    }, 200),
    initChart() {
      this.chart = echarts.init(document.getElementById("pie-chart"));
      const that = this
      this.chart.on('click', function(params) {
        that.dataIndex = params.dataIndex
      })
      this.chart.setOption({
        // 暂时去掉，iOS 上兼容有点问题，有时候无法隐藏
        // tooltip: {
        //   // see https://echarts.apache.org/zh/option.html#tooltip
        //   confine: true,
        //   trigger: "item",
        //   formatter:
        //     '<div style="padding:12px;">{b}(ONT) :</br> <span style="font-weight:700;">{c} ({d}%)</span></div>',
        // },

        legend: {
          left: "center",
          show: false,
          bottom: "10",
          data: ["Total Stake Amount", "Total ONT Supply"],
        },
        color: ["#48A3FF", "#F2F2F2"],
        series: [
          {
            name: "ONT Amount",
            type: "pie",
            roseType: false,
            radius: ["65%", "85%"],
            center: ["50%", "50%"],
            silent: true, // 禁用选中效果

            data: [
              {
                value: this.totalstake,
                name: "Total Stake Amount",
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                  emphasis: {
                    show: false,
                  },
                },
              },
              {
                value: this.totalnostake,
                name: "Total no-Staking Amount",
                label: {
                  show: false,
                },
                emphasis: {
                  itemStyle: {
                    color: ["#F2F2F2"],
                  },
                },
                labelLine: {
                  show: false,
                  emphasis: {
                    show: false,
                  },
                },
              },
            ],
            animationEasing: "cubicInOut",
            animationDuration: 2600,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pie-chart {
  height: 300px;
  width: 300px;

  @include mobile {
    height: 150px;
    width: 150px;
  }
}
</style>
